<template>
    <div class="container-list-post">
        <div class="header-list-post">
            <div class="title">
                <h4>Publications programmées</h4>
                <div class="btns">
                    <div class="btn-secondary" @click="newPost">
                        Créer un post
                    </div>
                    <!-- <div class="btn-outline-primary icon-r">
                        Tout les posts
                        <i class="fa-solid fa-caret-down"></i>
                    </div> -->
                </div>
            </div>
            <div class="description">
                <p>Gérez et réorganisez vos publications <br>pour voir à quoi votre grille ressemblera</p>
            </div>
        </div>

        <div class="list-group hide-scrollbar">
            

            <div class="group" v-for="(list, key, index) in lists">
                <div class="date">
                    <p>{{ datesFormat[index] }}</p>
                </div>

                <draggable
                    id="first"
                    data-source="juju"
                    v-bind="dragOptions"
                    :list="list"
                    class="events"
                    draggable=".event"
                    group="a"
                    :dragging-class="'dragging'"
                    @update="updateList"
                    @remove="updateList"
                        
                >
                    <transition-group type="transition" :name="'flip-list'">
                        <div class="event card-status-background-color" 
                            v-for="element in list" 
                            :id="element.id"  
                            :class="element.status"  
                            :key="element.id"
                            @click="()=>$emit('selectEvent',element)"
                        >
                            <div class="grip">
                                <i class="fa-solid fa-grip-dots-vertical card-status-color" :class="element.status"></i>
                            </div>
                            <div class="content-event">
                                <div class="picture">
                                    <img :src="element.url"/>
                                </div>
                                <div class="container-text">
                                    <div class="text">
                                        <p class="hours">{{element.format_date}}</p>
                                        <p class="content-post">{{ element.name }}</p>
                                    </div>
                               
                                    <div class="badges">
                                        <div class="badge badge-status" :status="element.status">{{$t(`dash.post.${element.status}`)}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition-group>
                </draggable>
            </div>
        </div>
    </div>
</template>

<script>

import draggable from 'vuedraggable'

export default {
    
    components: {
        draggable
    },

    mixins: [],

    props: {
        groups: Object
    },

    data() {
        return {
            lists: {}
        }
    },

    methods: {
        updateList(e) {
            this.$nextTick(()=>{
                const postId =  e.item.id
                const msInterval = 5 * 60 * 1000 //5minutes

                let itemIndex = -1 
                let newDate
                for (const [dateString, posts] of Object.entries(this.lists)) {
                    itemIndex = posts.findIndex(post => post.id == postId)
                
                    if (itemIndex >= 0) {
                        console.log('find',itemIndex,dateString)
                        
                        if (itemIndex == 0 && posts[1]) {
                            //retire 5minutes par rapport a l'avant derniere date
                            console.log("first", posts[1].date)
                            newDate = new Date(new Date(posts[1].date).getTime() + msInterval).toISOString()
                            posts[itemIndex].date = newDate
                            break;
                        }

                        if (itemIndex == posts.length - 1 && posts[itemIndex-1]) {
                            console.log("last", posts[itemIndex-1].date)
                            //ajouter 5minutes par rapport a la derniere date
                            newDate = new Date((new Date(posts[itemIndex-1].date)).getTime() - msInterval).toISOString()
                            posts[itemIndex].date = newDate
                            break;
                        }

                        const datePostBefore = new Date(posts[itemIndex+1].date).getTime() 
                        const datePostAfter = new Date(posts[itemIndex-1].date).getTime()
                        if (e.newIndex > e.oldIndex) {
                            //ajoute 5minutes par rapport a la date d'avant
                            console.log("ajoute 5minutes par rapport a la date plus future")
                            newDate = datePostAfter - msInterval
                            
                            if (newDate <= datePostBefore) {
                                newDate = (datePostAfter - datePostBefore) / 2 + datePostBefore
                            }

                            newDate = new Date(newDate).toISOString()
                            posts[itemIndex].date = newDate
                            break;
                        }else{
                            //ajoute 5minutes par rapport a la date d'apres
                            console.log("ajoute 5minutes par rapport a la date plus proche",newDate,datePostAfter)
                            newDate = datePostBefore + msInterval
                        
                            if (newDate >= datePostAfter) {
                                newDate = (datePostAfter - datePostBefore) / 2 + datePostBefore
                            }

                            newDate = new Date(newDate).toISOString()
                            posts[itemIndex].date = newDate
                            break;
                        }
                        break
                    }
                }
            

                if (itemIndex >= 0 && newDate) {
                    const postsSort = Object.values(this.lists).flat()

                    this.$emit('changeDate', {
                        postId,
                        newDate,
                        itemsSort:postsSort,
                        refreshGroupedItems: false
                    })
            
                }
            })
            
        },
        newPost() {
            this.$router.push({
                name: 'postCreator',
            })
        }
    },

    watch: {
        groups: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
               this.lists = JSON.parse(JSON.stringify(this.groups))
            }
        }
    },

    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },

        datesFormat() {
            return Object.keys(this.groups).map((dateStr) => {
                return new Date(dateStr).toLocaleDateString(undefined, { 
                    weekday: 'long',
                    day: 'numeric', 
                    month: 'long', 
                    year: 'numeric' 
                });
            });
        }
    }
} 
</script>